module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uvKrKLxXwjeGJXh7jFql6q6"
    }
  }, [_c('a', {
    attrs: {
      "id": "upMYBwFkR5aNoFJEL8vbrHA"
    }
  }), _vm._v("PART I")]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER-SUB"
  }, [_vm._v("FLEDGLING KILL")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("“I always had a desire to inflict pain on others and to have others inflict pain on me. I always seemed to enjoy everything that hurt.”")]), _vm._v(" "), _c('p', {
    staticClass: "quote _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("— Albert Fish")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(", ")]), _c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("The Gray Man")])]), _vm._v(" "), _c('p', {
    staticClass: "quote _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "italics _idGenCharOverride-1"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cab8203","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/PartOne.vue
// module id = 75
// module chunks = 0